import { GeneratedAudiencesStatusProps } from 'types/components/audiences';
import GeneratedAudiencesStatusView from './GeneratedAudiencesStatus.View';

const GeneratedAudiencesStatus = (props: GeneratedAudiencesStatusProps) => (
  <GeneratedAudiencesStatusView {...props} />
);

export default GeneratedAudiencesStatus;
